<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="860px"
    :title="dialogTitle"
    :visible.sync="dialogFormVisible"
    @opened="opened"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
        <el-input v-model="editForm.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="分类" :label-width="formLabelWidth" prop="classType">
        <el-select
          class="search-select"
          v-model="editForm.classType"
          placeholder="选择分类"
          style="width: 100%;"
        >
          <el-option label="项目动态" :value="1"></el-option>
          <el-option label="热点新闻" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="广告图片"
        :label-width="formLabelWidth"
        prop="headImg"
      >
        <el-upload
          class="avatar-uploader"
          :action="actionUrl"
          :show-file-list="false"
          :http-request="httpRequest"
        >
          <img v-if="editForm.headImg" :src="editForm.headImg" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        label="发布时间"
        :label-width="formLabelWidth"
        prop="dateNews"
      >
        <el-date-picker
          class="search-picker"
          v-model="editForm.dateNews"
          type="datetime"
          placeholder="选择日期"
          style="width: 100%;"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-form-item>
      <el-form-item
        label="发布状态"
        :label-width="formLabelWidth"
        prop="status"
      >
        <el-select
          class="search-select"
          v-model="editForm.status"
          placeholder="选择状态"
          style="width: 100%;"
        >
          <el-option label="编辑中" :value="1"></el-option>
          <el-option label="已发布" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="新闻内容"
        :label-width="formLabelWidth"
        prop="content"
      >
        <div id="newEditor"></div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          resetFrom('editForm');
          dialogFormVisible = false;
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import wangeditor from 'wangeditor';
// import MyEditor from '@/components/Editor/MyEditor';
import { getToken } from '@/utils/token.js';
import E from 'wangeditor';
import { formData, formRules } from '../form.js';
import {
  newsAdd,
  newsEdit,
  newsUpload,
  newsGetContent,
} from '@/api/newsApi.js';
// import { createEditor } from '@wangeditor/editor';
export default {
  name: 'editNews',
  components: {
    // MyEditor,
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      newId: '',
      dialogTitle: '',
      dialogFormVisible: false,
      editData: {},
      editForm: { ...formData }, // 编辑表单
      editRules: formRules, // 表单的验证规则,
      actionUrl: '',
      editor: null,
      //   defaultContent: null, // 富文本
    };
  },
  inject: ['reload'],
  mounted() {
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.editor = new E('#newEditor');
    //   }, 500);
    //   // 或者 const editor = new E( document.getElementById('div1') )
    // });
  },
  methods: {
    resetFrom() {
      this.newId = '';
      this.editForm = { ...formData };
      // 销毁编辑器
      if (!this.editor) return;
      this.editor.destroy();
      this.editor = null;
    },

    submitEdit() {
      try {
        this.editForm.content = this.editor.txt.html();
        this.$refs.editForm.validate(async (valid) => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!');
          // 获取编辑后的html
          this.editForm.content = this.editor.txt.html();
          const areaId = localStorage.getItem('areaId')
            ? JSON.parse(localStorage.getItem('areaId')).areaId
            : '';
          // console.log('新闻内容', this.editForm.content);
          if (!this.editForm.content)
            return this.$message.error('请填写新闻内容!');

          if (this.newId != '') {
            await newsEdit(this.newId, { ...this.editForm, areaId }).then(
              (res) => {
                if (res.code === 200) {
                  this.$message.success('编辑成功!');
                } else {
                  this.$message.error('编辑失败!');
                  return;
                }
              }
            );
          } else {
            await newsAdd({ ...this.editForm, areaId }).then((res) => {
              if (res.code === 200) {
                this.$message.success('新增成功!');
              } else {
                this.$message.error('新增失败!');
                return;
              }
            });
          }
          this.dialogFormVisible = false;
          this.editForm = {};
          // 重新获取数据
          this.reload();
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    httpRequest(options) {
      let file = options.file;
      let reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
      }
      reader.onload = () => {
        let base64Str = reader.result;
        this.dealImg(options, base64Str, file);
      };
    },
    dealImg(options, base64Str, file) {
      let _this = this;
      var image = new Image();
      image.src = base64Str;
      image.setAttribute('crossOrigin', 'Anonymous');

      image.onload = function () {
        // 缩放图片需要的canvas（也可以在DOM中直接定义canvas标签，这样就能把压缩完的图片不转base64也能直接显示出来）
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        // 图片原始尺寸
        var originWidth = this.width;
        var originHeight = this.height;

        // 最大尺寸限制，可通过设置宽高来实现图片压缩程度
        var maxWidth = 4200,
          maxHeight = 4200;
        // 目标尺寸
        var targetWidth = originWidth,
          targetHeight = originHeight;
        // 图片尺寸超过300x300的限制
        if (originWidth > maxWidth || originHeight > maxHeight) {
          if (originWidth / originHeight > maxWidth / maxHeight) {
            // 更宽，按照宽度限定尺寸
            targetWidth = maxWidth;
            targetHeight = Math.round(maxWidth * (originHeight / originWidth));
          } else {
            targetHeight = maxHeight;
            targetWidth = Math.round(maxHeight * (originWidth / originHeight));
          }
        }
        // canvas对图片进行缩放
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        // 清除画布
        context.clearRect(0, 0, targetWidth, targetHeight);
        // 图片压缩
        context.drawImage(image, 0, 0, targetWidth, targetHeight);
        /*第一个参数是创建的img对象；第二三个参数是左上角坐标，后面两个是画布区域宽高*/

        //压缩后的图片转base64 url
        /*canvas.toDataURL(mimeType, qualityArgument),mimeType 默认值是'image/png';
         * qualityArgument表示导出的图片质量，只有导出为jpeg和webp格式的时候此参数才有效，默认值是0.92*/
        var base64 = canvas.toDataURL('image/jpeg', 0.92); //base64 格式
        newsUpload({
          base64String: base64,
          fileName: file.name,
        })
          .then((res) => {
            _this.editForm.headImg = res.data.absoluteFileUrl;
          })
          .catch((err) => {
            window.console.log(err);
          });
      };
    },
    init() {
      if (this.editData != null && this.newId) {
        this.editForm.title = this.editData.title;
        if (this.editData.class != null) {
          this.editForm.classType = this.editData.class.status;
        }
        this.editForm.headImg = this.editData.headImg;
        this.editForm.dateNews = this.editData.dateNews;
        this.editForm.status = this.editData.status;
      }
    },
    async getContent() {
      await newsGetContent(this.newId).then((res) => {
        // console.log(res.data.content)
        // if (res.data != null) this.editForm.content = res.data.content;
        // this.editForm.content = res.data ? res.data.content : '';

        let token = getToken();
        let newToken = JSON.parse(token);

        this.editForm.classType = res.data ? res.data.classType : 1;
        const content = res.data ? res.data.content : '';
        this.editor = new E('#newEditor');
        this.editor.config.uploadImgMaxSize = '5 * 1024 * 1024'; //控制图片大小
        this.editor.config.uploadFileName = 'file'; // 上传参数
        this.editor.config.showLinkImg = false; // 隐藏插入网络图片的功能
        this.editor.config.uploadImgServer = `${window.RequestUrl}/upload/images/photo`; //上传图片
        this.editor.config.uploadImgHeaders = {
          authorization: 'Bearer ' + newToken.accessToken,
        };
        this.editor.create();

        // 上传图片 insertImgFn
        this.editor.config.uploadImgHooks = {
          // 上传图片之前
          before(xhr) {
            console.log(xhr);

            // 可阻止图片上传
            return {
              prevent: false, // 是否阻止上传
              msg: '图片上传错误',
            };
          },
          // 图片上传并返回了结果，图片插入已成功
          success(xhr) {
            console.log('success', xhr);
          },
          // 图片上传并返回了结果，但图片插入时出错了
          fail(xhr, editor, resData) {
            console.log('fail', resData);
          },
          // 上传图片出错，一般为 http 请求的错误
          error(xhr, editor, resData) {
            console.log('error', xhr, resData);
          },
          // 上传图片超时
          timeout(xhr) {
            console.log('timeout', xhr);
          },
          // 图片上传并返回了结果，想要自己把图片插入到编辑器中
          // 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
          customInsert(insertImgFn, result) {
            // result 即服务端返回的接口
            console.log('customInsert', result);
            if (result.code == 200) {
              // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
              insertImgFn(result.data);
            } else {
              this.$message.error('服务器出错');
            }
          },
        };

        this.editor.txt.append(content);

        // 这里开始初始化editor
        // let that = this;
        // setTimeout(function () {
        //   // 楼盘特色
        //   if (that.editor0 === undefined) {
        //     that.editor0 = new wangeditor('.toolbar0', '.content0');
        //     // 注册 change事件,创建的时候 把this 绑定 为 上一级的this
        //     that.editor0.customConfig.onchange = (html) => {
        //       that.editForm.content = html;
        //     };

        //     that.editor0.customConfig.uploadImgMaxSize = 5 * 1024 * 1024; //控制图片大小
        //     that.editor0.customConfig.uploadFileName = 'file'; //上传参数 自定义
        //     that.editor0.customConfig.uploadImgServer =
        //       'https://ezs.evoc.cn:7202/upload/images/photo'; //上传图片

        //     that.editor0.customConfig.uploadImgHooks = {
        //       customInsert: function (insertImg, result) {
        //         var url = result.data;
        //         insertImg(url);
        //       },
        //     };

        //     // create方法
        //     that.editor0.create();
        //   }
        //   that.editor0.txt.html(that.editForm.content);
        // }, 20);
      });
    },
    opened() {
      this.init();
      this.getContent();
    },
    beforeDestroy() {
      // 销毁编辑器
      this.editor.destroy();
      this.editor = null;
    },
  },
  created() {},
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  min-height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 200px;
  display: block;
}

.toolbar {
  border: 1px solid #ccc;
  width: 100%;
}

.el-form-item {
  margin-bottom: 5px;
}

.content {
  border: 1px solid #ccc;
  width: 100%;
  min-height: 200px;
}
</style>
